import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'rsuite';
import { FRAME_BORDER, FRAME_RADIUS } from './playtestStyles';

const SPACING = { gap: 8, padding: 12 };

const styles = {
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACING.gap,
    padding: SPACING.padding,
    border: FRAME_BORDER,
    borderRadius: FRAME_RADIUS,
  },
  row: { display: 'flex', flexWrap: 'wrap', gap: SPACING.gap },
};

/**
 * Asks where a command-zone card should go when it leaves the command zone.
 * The caller decides what each choice dispatches; nothing is sent until one is chosen.
 */
const ReplacementPrompt = ({ name, destinationLabel, onDestination, onCommand, onCancel }) => (
  <div data-testid="replacement-prompt" style={styles.panel}>
    <span>{`${name} is a command-zone card. Where should it go?`}</span>
    <div style={styles.row}>
      <Button size="xs" data-testid="replacement-prompt-destination" onClick={onDestination}>
        {destinationLabel}
      </Button>
      <Button size="xs" data-testid="replacement-prompt-command" onClick={onCommand}>
        Command zone instead
      </Button>
      <Button size="xs" data-testid="replacement-prompt-cancel" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  </div>
);

ReplacementPrompt.propTypes = {
  name: PropTypes.string.isRequired,
  destinationLabel: PropTypes.string.isRequired,
  onDestination: PropTypes.func.isRequired,
  onCommand: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ReplacementPrompt;
